var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PuzzleCell',{class:{
        'c-grid__cell--solution': true,
        'c-grid__cell--active': _vm.isActive
    },attrs:{"xIndex":_vm.index,"yIndex":0,"text":_vm.text ? _vm.text.toUpperCase() : ''}})
}
var staticRenderFns = []

export { render, staticRenderFns }